import {
  Loadboard,
  PostToLoadboardCommand,
  PostToLoadboardResponse,
} from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment';

export class ShipmentLoadboardController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getAll(shipmentId: number): Promise<Loadboard[]> {
    const response = await this.http.get<Loadboard[]>(
      `${shipmentId}/loadboard/active`,
    );
    return response.data.map((item) => new Loadboard(item));
  }

  async post(
    shipmentId: number,
    command: PostToLoadboardCommand,
  ): Promise<PostToLoadboardResponse[]> {
    const response = await this.http.post<PostToLoadboardResponse[]>(
      `${shipmentId}/loadboard/post`,
      command,
    );
    return response.data.map((item) => new PostToLoadboardResponse(item));
  }

  async remove(shipmentId: number, loadboardId: number): Promise<void> {
    await this.http.delete(`${shipmentId}/loadboard/${loadboardId}`);
  }

  async forceRemove(shipmentId: number, loadboardId: number): Promise<void> {
    await this.http.delete(`${shipmentId}/loadboard/${loadboardId}/force`);
  }
}
